import { useLoader } from '@react-three/fiber';
import { memo, useLayoutEffect, useMemo, useRef } from 'react';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';
import { Box3, Sphere, Vector3 } from 'three/src/Three';

type Props = {
  url: string;
  name: string;
  pos: Array<number>;
  rot?: Array<number>;
  segment?: number;
  refVal?: any;
};

const SvgImporter = ({
  url,
  pos,
  rot = [-Math.PI / 2, 0, 0],
  segment = 100,
  refVal = null,
  name,
}: Props) => {
  const data = useLoader(SVGLoader, url);
  const shapes = useMemo(
    () =>
      data.paths.flatMap((g, index) =>
        g.toShapes(true).map((shape) => ({ shape, color: g.color, index }))
      ),
    [data]
  );

  return (
    <group ref={refVal} name={name}>
      <group
        position={[pos[0], pos[1], pos[2]]}
        rotation={[rot[0], rot[1], rot[2]]}
      >
        {shapes.map((ele, index) => (
          <mesh key={index} scale={0.0027}>
            <shapeGeometry args={[ele.shape, segment]} />
            <meshBasicMaterial
              color={ele.color}
              transparent
              opacity={1}
              toneMapped={false}
              depthWrite={false}
            />
          </mesh>
        ))}
      </group>
    </group>
  );
};

export default memo(SvgImporter);
